import {
  FormErrorMessage,
  FormControl,
  Select,
  SystemStyleObject,
  Text,
  Flex,
} from "@chakra-ui/react";
import { Control, useController } from "react-hook-form";
import LabelComponent from "../../atom/Label/LabelComponent";
import { REQUIRED_FIELD } from "../../../utils/constants";
import { ChangeEvent, FC } from "react";
import { Option } from "../../../types/General/Option";
import SpinnerComponent from "../../atom/Spinner/SpinnerComponent";

export interface SelectComponentProps {
  errors?: any;
  fieldNameObject: string;
  options: Option[];
  fieldName?: string;
  isRequired?: boolean;
  width?: string;
  placeholder?: string;
  control: Control<any>;
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  isDisabled?: boolean;
  additionalStyle?: SystemStyleObject;
  additionalText?: string;
  defaultValue?: any;
  isLoaded?: boolean;
}

const SelectComponent: FC<SelectComponentProps> = ({
  errors,
  fieldNameObject,
  options,
  fieldName,
  isRequired,
  width,
  placeholder = "Seleccionar",
  control,
  onChange,
  isDisabled = false,
  additionalStyle,
  additionalText,
  defaultValue,
  isLoaded = true,
}) => {
  const {
    field: { onChange: onChangeHookForm, onBlur, value, name },
  } = useController({
    name: fieldNameObject,
    control,
    defaultValue: defaultValue || "" || undefined,
  });

  const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const selectedOption = options.find(
      (option) =>
        option.id && option.id.toString() === e.target.value.toString(),
    );
    onChangeHookForm(selectedOption || null);
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <FormControl
      isInvalid={errors && !!errors[fieldNameObject]}
      sx={additionalStyle}
    >
      <LabelComponent
        fontSize="md"
        fontWeight="500"
        title={fieldName ? fieldName : ""}
        isRequired={isRequired}
        helper={additionalText}
      />
      <Select
        id={fieldNameObject}
        placeholder={isLoaded ? placeholder : " "}
        onChange={handleChange}
        onBlur={onBlur}
        value={
          typeof value === "object" && value !== null
            ? value.id
            : value !== ""
              ? value
              : (defaultValue ?? "")
        }
        width={width}
        name={name}
        isDisabled={isDisabled || isLoaded === false}
        color={
          value === null || value?.id === "" || value === ""
            ? "gray.400"
            : "#000"
        }
      >
        {isLoaded ? (
          options.map((option) => (
            <option key={option.id} value={option.id}>
              {option.name}
            </option>
          ))
        ) : (
          <></>
        )}
      </Select>

      {!isLoaded && (
        <Flex
          paddingX="4"
          alignItems="center"
          position="absolute"
          top="55%"
          gap="2"
        >
          <SpinnerComponent />
          <Text color="gray.400">A carregar...</Text>
        </Flex>
      )}

      <FormErrorMessage>
        {errors && errors[fieldNameObject] && <>{REQUIRED_FIELD}</>}
      </FormErrorMessage>
    </FormControl>
  );
};

export default SelectComponent;
